import React, { useContext, useState } from "react"
import { Modal } from "react-bootstrap";
import {
  Autocomplete,
  Button,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  Switch,
  FormControlLabel
} from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function AddPieceModal({
  showModalAdd,
  setShowModalAdd,
  handleAddPieces,
  selectedAddPieces,
  grupoPecas,
  pecasOptions,
  postPieces,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  const [newGroup, setNewGroup] = useState(false);

  return (
    <Modal size="lg" show={showModalAdd} onHide={() => setShowModalAdd(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-3">
        <div className="d-flex flex-column gap-3">
          <div className="d-flex justify-content-start">
            <FormControlLabel
              className="d-flex align-items-center"
              label="NOVO GRUPO"
              control={
                <Switch
                  checked={newGroup}
                  onChange={() => setNewGroup(!newGroup)}
                />
              }
            />
          </div>

          <div className="d-flex flex-row gap-3">
            <div className="d-flex flex-column w-50">
              <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
                {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.labels.peca}
              </InputLabel>
              <Autocomplete
                options={pecasOptions}
                getOptionLabel={(opt) => `${opt.descricao} (${opt.valor})`}
                filterOptions={(opts, { inputValue }) =>
                  opts.filter(o =>
                    o.descricao.toLowerCase().includes(inputValue.toLowerCase()) ||
                    o.valor.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                onChange={(_, opt) => handleAddPieces({ name: "pecaGrupo_CodPeca", value: opt?.valor ?? "" }, "PECA")}
                renderInput={(params) => (
                  <TextField {...params} required fullWidth placeholder="Selecione a Peça" />
                )}
              />
            </div>

            <div className="d-flex flex-column w-50">
              <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
                {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.labels.grupo}
              </InputLabel>
              {newGroup ? (
                <TextField
                  name="pecaGrupo_Nome"
                  required
                  fullWidth
                  placeholder="Nome do Grupo"
                  onChange={({ target }) => handleAddPieces(target, "PECA")}
                />
              ) : (
                <Select
                  value={selectedAddPieces.pecaGrupo_Nome}
                  onChange={({ target }) => {
                    handleAddPieces({ name: "pecaGrupo_Nome", value: target.value }, "PECA")
                  }}
                >
                  {grupoPecas.map((itemProd, i) => (
                    <MenuItem
                      key={`grupPiece-${itemProd.prodGrupo_GrupoNome}-${i}`}
                      value={itemProd.prodGrupo_GrupoNome}
                    >
                      {itemProd.prodGrupo_GrupoNome}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalAdd(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => postPieces(selectedAddPieces)}
          disabled={checkSaveBtn(selectedAddPieces)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
